module.exports = __webpack_public_path__ + "img/8.e12272cd.jpg";